export default __webpack_public_path__ + "static/media/element_26.a1136a2a.jpg";